<template>
  <div class="adminAlarm alarmSNew">
    <div class="section" style="box-shadow:none;">
      <!-- <div class="alarmname">{{$t('alarm.Alarm_List')}}</div> -->
      <div class="search">
        <div class="left">
          <span class="search-label">{{ $t('alarm.Alarm_Type') }}</span>
          <el-select v-model="search.level" :placeholder="$t('header.pleaseSelect')" size="small" clearable
            @change="getData(true)" popper-class="select-search-recharge" class="selectClearNew">
            <el-option v-for="item in level" :key="item.value" :label="item.label" :value="item.value">
              <span class="select-label">{{ item.label }}</span>
            </el-option>
          </el-select>
          <!-- <span class="search-label">{{ $t('alarm.Device_Type') }}</span>
          <el-select v-model="search.brand" clearable size="small" @change="getData(true)"
            :placeholder="$t('header.pleaseSelect')" popper-class="select-search-recharge" class="selectClearNew"
            style="width:120px">
            <el-option v-for="item in $filter.deviceType" :key="item.value" :value="item.value"
              :label="item.label"></el-option>
          </el-select> -->
          <span class="search-label">{{ $t('alarm.Alarm_Status') }}</span>
          <el-select v-model="search.handle" size="small" clearable @change="getData(true)"
            popper-class="select-search-recharge" class="selectClearNew">
            <el-option v-for="item in handle" :key="item.value" :label="item.label" :value="item.value">
              <span class="select-label">{{ item.label }}</span>
            </el-option>
          </el-select>
          <el-date-picker :editable='false' @change="getData(true)" clearable v-model="datevalue"
            type="daterange" align="left" :default-value="new Date().setMonth(new Date().getMonth() - 1)" unlink-panels ref="datePickerRange" :range-separator="$t('report.to')"
            :picker-options="pickerrangeOptions" :start-placeholder="$t('report.start_date')" :end-placeholder="$t('report.End_date')"
             popper-class="select-date1">
          </el-date-picker>
        </div>
        <div class="right">
          <el-button class="button button-solid" @click.stop="showSearchBtn">
            <i class="el-icon-search"></i>
          </el-button>
          <button type="button" class="button-export" @click="exportReportMonth()">{{ $t('report.Export_alarm')
          }}</button>
          <div class="search-alert" v-if="showSearch">
            <div class="searchDiv">
              <el-input class="searchAll" ref="iptFocus" v-model.trim="search.search"
                @keyup.enter.native="getData(true)" :placeholder="this.$t('header.pnAndSN')" clearable>
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
              </el-input>
              <!-- 搜索 -->
              <span class="search-device" @click="getData(true)">{{ $t('recharge.Search') }}</span>
              <!-- 取消 -->
              <span class="search-hide" @click="closeSearch">{{ $t('rate.cancel') }}</span>
            </div>
          </div>
        </div>

        <!-- 批量操作弹条 (显隐由是否勾选决定) -->
        <div class="batch-alert" v-show="selectedAlarm.length">
          <!-- 当前选中条数 -->
          <span class="batch-total">
            {{ `${$t('alarm.curSelected')} ${selectedAlarm.length} ${$t('alarm._Data')}` }}
          </span>
          <div class="batch-right">
            <!-- 操作 -->
            <span class="batch-operate">
              <!-- 删除 -->
              <span class="btn" @click="detelealarm(selectedAlarm)">
                {{ $t('device.delete') }}
                <i class="ico ico-clear"></i>
              </span>
            </span>
            <!-- 取消 -->
            <span class="batch-hide" @click="closeBatch">{{ $t('rate.cancel') }}</span>
          </div>
        </div>
      </div>

      <el-table :data="alarmlist" border stripe height="100%" :row-style="{ height: 0 }" :cell-style="{ padding: 0 }"
        :header-cell-style="{ background: 'rgb(65, 80, 90)', color: '#ffffff' }" v-loading="alarmloading"
        element-loading-spinner="el-icon-loading" @selection-change="changeFun" class="tablemain tableloding"
        :empty-text="$t('account.nodata')" ref="multipleSnTable" :cell-class-name="addClass">
        <el-table-column type="selection" fixed></el-table-column>
        <el-table-column prop="gts" fixed min-width="180px;" :label="$t('alarm.Occurrence_time')"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="level" min-width="145px;" :label="$t('alarm.Alarm_Type')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <div :class="`background-${level[scope.row.level].name}`" style="border-radius: 5px;margin: 0 20px;">
              <span :class="`radius-${level[scope.row.level].name}`" style="width: 8px;height: 8px;border-radius: 8px;display: inline-block;margin-right: 5px;"></span>
              <span v-if="scope.row.level !== undefined" :class="`color-${level[scope.row.level].name}`">{{ level[scope.row.level].label }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column min-width="110px" prop="handle" :label="$t('alarm.Alarm_Status')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span v-if="scope.row.handle.class=='untreated'" style="color: #ec9630;">{{ scope.row.handle.label }}</span>
            <span v-else style="color: rgba(255,255 ,255 ,0.3 );">{{ scope.row.handle.label }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="100px;" :label="$t('alarm.Alarm_Code')" :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span :title="scope.row.code || '--'">{{ scope.row.code || '--' }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="desc" min-width="130px;" :label="$t('alarm.Alarm_Describe')"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="sn" min-width="150px;" :label="$t('alarm.Device_SN')"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span class="redirect" @click="enterDevice(scope.row)" :title="scope.row.deviceSn || scope.row.sn">{{
              scope.row.deviceSn || scope.row.sn || '--' }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="pn" min-width="130px;" :label="$t('alarm.Device_PN')"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="devaddr" min-width="85px;" :label="$t('alarm.device_address')"
          :show-overflow-tooltip="true"></el-table-column>
        <el-table-column fixed="right" :label="$t('alarm.Operation')" width="100">
          <template slot-scope="scope">
            <el-button type="text" class="operation" :title="$t('alarm.details')" @click="checkalarm(scope.row)">
              <i class="iconfont icon-a-mingchenggaojingrizhi2"></i>
            </el-button>
            <el-button type="text" class="operation" :title="$t('alarm.deletes')" @click="detelealarm([scope.row])">
              <i class="iconfont icon-caozuo_shanchu"></i>
            </el-button>
          </template>
        </el-table-column>
        <!-- 无数据 -->
        <!-- <div v-show="emptyText" slot="empty">
          <img src="@/assets/img/empty_text.png"/>
          <div style="line-height: 32px">{{$t('account.nodata')}}</div>
        </div> -->
      </el-table>

      <div class="tablebottom">
        <!-- 占个坑位，不然分页会掉出来屏幕之下 -->
        <!-- <div v-else class="pagination"></div> -->
        <!-- 批量删除 -->
        <!-- <button
          style="height:32px;margin-left:16px;"
          class="btn"
          :class="selectedAlarm.length ? 'btn-dark' : 'btn-disable'"
          @click="detelealarm(selectedAlarm)"
        >{{$t('alarm.Delete_selected')}}</button> -->
        <!-- 批量占位 -->
        <span class="" style="margin-left:16px;"></span>
        <!-- 分页 -->
        <!-- v-if="paginationControl" -->
        <el-pagination class="pagination" background @size-change="getData(true)" @current-change="() => getData()"
          :current-page.sync="pagination.currentPage" :page-sizes="[10, 15, 20, 30, 50]"
          :page-size.sync="pagination.pagesize" layout="slot, sizes, total, pager, prev, next, jumper"
          :total="pagination.total" popper-class='select-page'>
          <span style="color:#ffffff;padding-left:15px;">{{ $t('device.pageSize') }} :</span>
        </el-pagination>
      </div>
    </div>
    <!-- 告警详情 -->
    <deletesalarm-dialog :title="$t('alarm.alarmDetails')" width="460px"
      :class="{ 'showDialog': showcheckalarmdialog, 'hideDialog': !showcheckalarmdialog }"
      :visible.sync="showcheckalarmdialog" noFooter>
      <div class="content_tishi" slot="content">
        <div class="checkalarm">
          <div class="alarmdetails" style="color: #30D096;font-size: 16px;">{{ $t('alarm.alarmInfo') }}</div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.Occurrence_time') }}</span>
            <span>{{ checkData.gts }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.endtime') }}</span>
            <span>{{ checkData.cts||"--" }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.Alarm_Status') }}</span>
            <span v-if="checkData.handle.class=='untreated'" style="color: #ec9630;">{{ checkData.handle.label }}</span>
            <span v-else style="color: rgba(255,255 ,255 ,0.3 );">{{ checkData.handle.label }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.Alarm_Type') }}</span>
            <div :class="`background-${level[checkData.level].name}`" style="border-radius: 5px;padding: 0 10px;">
              <span :class="`radius-${level[checkData.level].name}`" style="width: 8px;height: 8px;border-radius: 8px;display: inline-block;margin-right: 5px;"></span>
              <span v-if="checkData.level !== undefined" :class="`color-${level[checkData.level].name}`">{{ level[checkData.level].label }}</span>
              <span v-else>{{ "--" }}</span>
            </div>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.Alarm_Code') }}</span>
            <span>{{ checkData.code }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.Alarm_Describe') }}</span>
            <span>
              <el-tooltip :content="checkData.desc" placement="top" effect="dark">
                <span class="ellipsis-span">
                  {{ checkData.desc }}
                </span>
              </el-tooltip>
            </span>
          </div>
        </div>
        <div class="checkalarm">
          <div class="alarmdetails" style="color: #30D096;font-size: 16px;">{{ $t('alarm.alarmDevice') }}</div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.Device_Type') }}</span>
            <span>
              <span>{{ brand[checkData.brand == fieldUndefined ? 10 : checkData.brand].label }}</span>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.Device_SN') }}</span>
            <!-- <span>{{ checkData.sn }}<i @click="copy(checkData.sn)" style="color:#33FFB6;padding-left:10px;" class="iconfont icon-biaogegongneng_fuzhi"></i></span> -->
            <span>
              <el-tooltip :content="checkData.deviceSn || checkData.sn" placement="top" effect="dark">
                <span class="ellipsis-span">
                  {{ checkData.deviceSn || checkData.sn }}
                </span>
              </el-tooltip>
              <i @click="copy(checkData.deviceSn || checkData.sn)" style="color:#33FFB6;padding-left:10px;" class="iconfont icon-biaogegongneng_fuzhi"></i>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.device_alias') }}</span>
             <span>
              <el-tooltip :content="checkData.alias || checkData.sn" placement="top" effect="dark">
                <span class="ellipsis-span">
                  {{ checkData.alias || checkData.sn || '--' }}
                </span>
              </el-tooltip>
            </span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.device_address') }}</span>
            <span>{{ checkData.devaddr }}</span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.Device_PN') }}</span>
            <span>{{ checkData.pn }}<i @click="copy(checkData.pn)" style="color:#33FFB6;padding-left:10px;" class="iconfont icon-biaogegongneng_fuzhi"></i></span>
          </div>
          <div class="alarmdetails">
            <span>{{ $t('alarm.User') }}</span>
            <span>
              <el-tooltip :content="checkData.usr" placement="top" effect="dark">
                <span style="color: #30D096;cursor:pointer" @click="enterDevice(checkData)" class="ellipsis-span">
                  {{ checkData.usr }}
                </span>
              </el-tooltip>
            </span>
          </div>
        </div>
        <div class="deletfotter" style="text-align:center;margin-top:28px;">
          <button class="btn btn-light" @click="showcheckalarmdialog=false">{{ $t('alarm.Close') }}</button>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警 去掉弹框的heard不加title=""和footer noFooter -->
    <!-- v-if="showdeletesalarmdialog" -->
    <deletesalarm-dialog :title="$t('alarm.deletes')"
      :class="{ 'showDialog': showdeletesalarmdialog, 'hideDialog': !showdeletesalarmdialog }"
      :visible.sync="showdeletesalarmdialog" noFooter>
      <div class="content_tishi" slot="content">
        <div class="tital">
          <!-- <i class="iconfont icon-gantanhao"></i> -->
          <span class="contentdelete" style="width:100%;text-align:left;">{{ $t('alarm.delete_alarm') }}</span>
        </div>
        <div class="disabledescr">
          <span style="width:100%;text-align:left;margin-top:28px;">{{ $t('account.notRecovered') }}</span>
        </div>
        <!-- <span class="contentdelete">{{$t('alarm.delete_alarm')}}</span> -->
        <div class="deletfotter" style="text-align:right;margin-top:28px;">
          <button class="btn btn-dark" style="margin-right:10px;" @click="configdelete">{{ $t('alarm.Confirm') }}</button>
          <button class="btn btn-light" @click="closeDialog">{{ $t('alarm.Cancel') }}</button>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警结果提示(成功) -->
    <!-- v-if="delAlarmSucVisible" -->
    <deletesalarm-dialog :title="$t('project.delResults')" :visible.sync="delAlarmSucVisible"
      :class="{ 'showDialog': delAlarmSucVisible, 'hideDialog': !delAlarmSucVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showsuccess"></span>
          <span class="showresulttext">{{ $t('project.delSuc') }}</span>
          <!-- <span class="showresulttext">{{deviceTipMsg}}</span> -->
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="delAlarmSucVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
    <!-- 删除告警结果提示(失败) -->
    <!-- v-if="delAlarmFailVisible" -->
    <deletesalarm-dialog :title="$t('project.delResults')" :visible.sync="delAlarmFailVisible"
      :class="{ 'showDialog': delAlarmFailVisible, 'hideDialog': !delAlarmFailVisible }" width="500px" noFooter>
      <div slot="content">
        <div class="showresultbox">
          <span class="showbase showfail"></span>
          <span class="showresulttext">{{ alarmTipMsg }}</span>
          <!-- 确定 -->
          <div class="showoperate">
            <button type="button" class="btn btn-dark" @click="delAlarmFailVisible = false;">{{ $t('datalogger.confirm')
            }}</button>
          </div>
        </div>
      </div>
    </deletesalarm-dialog>
  </div>
</template>
<script>
import deletesalarmDialog from "@/components/dialognew";
import { mapGetters } from "vuex";
// 解决'_t' of null报错
import { i18n } from '@/i18n';
export default {
  components: {
    deletesalarmDialog //删除弹框
  },
  data () {
    return {
      //表格字段数据判断
      fieldUndefined: undefined,
      selectedDate: '', // 所选时间
      // 操作返回提示
      alarmTipMsg: "",
      // 删除告警成功提示
      delAlarmSucVisible: false,
      // 删除告警失败提示
      delAlarmFailVisible: false,
      emptyText: false,
      paginationControl: false,
      isUnfold: true,
      activeTab: "device",
      tabs: [
        {
          id: "device",
          label: this.$t("alarm.Alarm_List")
        }
      ],
      alarmloading: false,
      showdeletesalarmdialog: false,
      selectedAlarm: [], //批量删除
      search: {
        level: "",
        brand: "",
        handle: "false",//默认为处理(减少后端响应时间)
        sn: "",
        search:"",
      },
      // 设备类型
      brand: {
        0: {
          value: "0",
          label: i18n.t('device.brand0')
        },
        1: {
          value: "1",
          label: i18n.t('device.brand1')
        },
        2: {
          value: "2",
          label: i18n.t('device.brand2')
        },
        3: {
          value: "3",
          label: i18n.t('device.brand3')
        },
        // 无返回值字段处理
        10: {
          value: "10",
          label: "--",
        },
      },
      level: [
        {
          label: this.$t("alarm.warning"),
          value: "0",
          name:"warning"
        },
        {
          label: this.$t("alarm.error"),
          value: "1",
          name:"standby"
        },
        {
          label: this.$t("alarm.fault"),
          value: "2",
          name:"fault"
        }
      ],
      devcode: [
        {
          value: "512",
          label: this.$t("alarm.inverter")
        },
        {
          value: "768",
          label: this.$t("alarm.monitor")
        },
        {
          value: "1024",
          label: this.$t("alarm.smart_meters")
        },
        {
          value: "1280",
          label: this.$t("alarm.combining_manifolds")
        },
        {
          value: "1536",
          label: this.$t("alarm.Camera")
        },
        {
          value: "1792",
          label: this.$t("alarm.Battery")
        },
        {
          value: "2048",
          label: this.$t("alarm.Charger")
        },
        {
          value: "2304",
          label: this.$t("alarm.storage")
        },
        {
          value: "2560",
          label: this.$t("alarm.Prevent_arcing_island")
        },
        {
          value: "2816",
          label: this.$t("alarm.Microinverter")
        }
      ],
      handle: [
        {
          value: "true",
          label: this.$t("alarm.processed")
        },
        {
          value: "false",
          label: this.$t("alarm.untreated")
        }
      ],
      alarmlist: [],
      pagination: {
        currentPage: 1,
        total: 0,
        pagesize: 15
      }, // 分页数据
      params: "",
      showSearch:false,
      datevalue:"",
      //自定义日期选择限定31天
      pickerrangeOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now() - 8.64e6
        },
      },
      checkData:{
        gts:"",
        cts:"",
        handle:{
        },
        level:0,
        code:"",
        desc:"",
        brand:0,
        deviceSn:"",
        sn:"",
        alias:"",
        devaddr:"",
        pn:"",
        usr:"",
      },
      showcheckalarmdialog:false,
      infoCopy:String,
    };
  },
  mounted () {
    this.getData();
  },
  computed: {
    ...mapGetters({
      deviceInfo: 'getDeviceInfo'
    })
  },
  watch: {
  },
  methods: {
    //复制功能
    copy (info) {
      this.infoCopy = info
      //创建input标签
      var input = document.createElement('input')
      //将input的值设置为需要复制的内容
      input.value = this.infoCopy;
      //添加input标签
      document.body.appendChild(input)
      //选中input标签
      input.select()
      //执行复制
      document.execCommand('copy')
      //成功提示信息
      this.$message.success(this.$t("datalogger.copy"))
      //移除input标签
      document.body.removeChild(input)
    },
    // 打开搜索栏
    showSearchBtn () {
      this.search={
        level: "",
        brand: "",
        handle: "",//默认未处理(减少后端响应时间)
        sn: "",
        search:"",
      }
      this.datevalue=""
      this.showSearch = true;
      this.$nextTick(() => {
        this.$refs.iptFocus.focus();
      })
    },
    // 关闭搜索框
    closeSearch () {
      this.showSearch = false;
      this.search.search= '';
      this.search.handle= 'false';
      this.getData(true);
    },
    //跳转告警设备告警列表
    enterDevice (info) {
      this.$router.push({
        // path: "/generalNew/home",
        path: `/generalNew/home`,
        query: {
          tab: "alarm",
          devcode: info.devcode,
          pn: info.pn,
          devaddr: info.devaddr,
          sn: info.sn,
          pid: info.pid,
        }
      });
    },
    //表格设备名称修改超出隐藏省略号颜色
    addClass ({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 3) {
        return "deviceName"
      }
    },
    // 导出告警列表
    exportReportMonth () {
      let param = {
        action: "exportWarnings",
        i18n: this.$lang.currentLang,
        devtype: 2304,
        edate: this.$tool.getBeforeDate(0),
        sdate: this.$tool.getBeforeDate(30),
      }
      this.$request
        .get("exportWarnings", param)
        .then(res => {
          // 演示账号
          if (res.err) {
            if (res.err == 264) {
              this.$message.error(this.$t("report.no_deAlarm"));
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`));
            }
            return;
          } else {
            window.location.href = this.$request.http_download_url_new(param)
            this.getData();
          }
          this.$message.success(this.$t("report.download"));
        })
        .then(() => {
          // this.$message.success(this.$t("report.download"));
        }).catch((err) => {
          this.$message.error(err);
        });
    },
    //获取表格数据
    getData (reset) {
      this.paginationControl = false;
      if (reset) this.pagination.currentPage = 1;
      let param = {
        // (总告警)
        ...this.search,
        devtype: 2304,
        i18n: this.$lang.currentLang,
        pagesize: this.pagination.pagesize,
        page: this.pagination.currentPage - 1,
        sdate: this.datevalue?this.$filter.formatDate(this.datevalue[0]):"",
        edate:  this.datevalue?this.$filter.formatDate(this.datevalue[1],"yyyy-MM-dd") + ' 23:59:59':"",
        mode:this.datevalue?"strict":"",
       };
      this.alarmloading = true;
      // this.$request.get('webQueryPlantsWarning',param,'http://api.shinemonitor.com/dis05/').then(res=>{
      this.$request.get("webQueryPlantsWarning", param).then(res => {
        if (res.err == 0) {
          res.dat.warning.forEach(item => {
            // item.level = item.level ==0?this.$t('alarm.warning'):(item.level ==1?this.$t('alarm.error'):(item.level ==2?this.$t('alarm.fault'):this.$t('alarm.offline')))
            item.handle = item.handle
              ? {
                label: i18n.t("alarm.processed"),
                class: "processed"
              }
              : {
                label: i18n.t("alarm.untreated"),
                class: "untreated"
              };
          });
          this.alarmlist = res.dat.warning;
          this.pagination.total = res.dat.total;
          if (this.pagination.total > this.pagination.pagesize) {
            this.paginationControl = true
          }
        } else {
          // this.$message.warning(this.$t(`errCode.${res.err}`));
          this.emptyText = true;
          this.alarmlist = [];
          this.pagination.total = 0;
        }
        this.alarmloading = false;
      });
    },
    //取消按钮
    closeDialog () {
      this.showdeletesalarmdialog = false;
    },
    //勾选多项
    changeFun (val) {
      this.selectedAlarm = val; // 返回的是选中的列的数组集合
    },
    //查看按钮
    checkalarm (info) {
      this.checkData=info
      this.showcheckalarmdialog = true;
    },
    //删除按钮
    detelealarm (info) {
      if (!info.length) return false;
      var PNAll = [];
      info.forEach(item => {
        PNAll.push(item.id);
      });
      this.pnbox = PNAll;
      this.showdeletesalarmdialog = true;
    },
    //确定删除告警
    configdelete () {
      this.$request
        .get("ignorePlantWarning", { id: this.pnbox.join(",") })
        .then(res => {
          if (res.err == 0) {
            // this.$message.success(this.$t("alarm.deleted_successfully"));
            this.delAlarmSucVisible = true;
            this.showdeletesalarmdialog = false;
            this.getData();
          } else {
            // this.$message.error(this.$t(`errCode.${res.err}`));
            this.alarmTipMsg = this.$t(`errCode.${res.err}`);
            this.delAlarmFailVisible = true;
          }
        });
    },
    handleAccountCommand (command) {
      switch (command) {
        case "device":
          this.activeTab = "account";
          break;
        default:
          break;
      }
    },
    folding () {
      if (this.isUnfold) {
        this.isUnfold = !this.isUnfold;
      } else {
        this.isUnfold = !this.isUnfold;
      }
    },
    // 关闭批量操作弹条
    closeBatch () {
      // this.showBatch = false;
      // 用是否选中来控制批量弹条显隐
      // this.selectedAlarm = [];
      // 手动取消勾选
      this.$refs.multipleSnTable.clearSelection();
    },
  }
};
</script>
<style lang="less" scoped>
@import url("../../assets/css/mixin.less");

.alarmSNew {
  flex: 1;
  display: flex;
  flex-direction: column;
  .checkalarm{
    background-color:rgba(43,63 ,75) ;
    padding: 24px 20px;
    border-radius: 11px;
    margin-bottom: 20px;
    .alarmdetails{
      display: flex;
      justify-content: space-between;
      padding-bottom: 10px;
      color: rgba(255,255,255,0.7);
            .ellipsis-span {
  display: inline-block;
  max-width: 250px;      /* 根据实际宽度调整 */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}
    }
  }

  // margin-top: 20px;
  // margin: 20px;
  // background-color: rgb(34, 45, 53);
  // 统一按钮
  .button-export {
    height: 48px;
    background: @primaryTextColor;
    color: rgb(34, 45, 53);
    font-size: 14px;
    border-radius: 0px;
    border: none;
    cursor: pointer;
  }

  .btn {
    padding: 6px 12px;
    border-radius: 6px;
    font-size: 14px;
    cursor: pointer;
  }

  .btn-disable {
    color: rgba(242, 242, 242, 0.5);
    background: rgba(43, 56, 66, 1);
    cursor: not-allowed;
  }

  .btn-dark {
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    border: none;
  }

  .btn-light {
    background: transparent;
    color: @primaryTextColor;
    border: 1px solid @primaryTextColor;
  }

  overflow: auto;

  .section {
    display: flex;
    flex: 1;
    padding: 0px;
    margin: 20px 20px 35px;
    flex-direction: column;
    border-radius: 0px;
    border: none;
    background: rgb(34, 45, 53);
    position: relative;
    // overflow: auto;
    overflow: hidden;

    /deep/.el-icon-loading {
      font-size: 28px;
    }

    .search {
      margin: 0px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background: rgb(34, 45, 53);
      .search-alert {
        position: absolute;
        top: 0;
        // left: 0;
        right: 0;
        width: 100%;
        height: 48px;
        z-index: 1;
        background: rgb(34, 45, 53);
        display: flex;
        align-items: center;
        justify-content: space-between;

        .searchDiv {
          position: absolute;
          top: 0;
          // left: 0;
          right: 0;
          width: 400px;
          height: 48px;
          z-index: 2;
          background: rgb(34, 45, 53);
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .searchAll {
          /deep/.el-input__inner {
            width: 220px;
            padding-left: 10px !important;
          }
        }

        .search-device {
          display: inline-block;
          line-height: 48px;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #33FFB6;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        .search-hide {
          display: inline-block;
          // position: absolute;
          // right: -58px;
          // line-height: 48px;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0 15px;
          font-size: 14px;
          background: #202D35;
          color: #7B8395;
          border-left: 1px solid #7B8395;
          cursor: pointer;

          &:hover {
            background: @primaryColorTransparency30;
            color: rgb(255, 255, 255, 1);
          }
        }

        /deep/.el-input {
          flex: 1;
        }

        /deep/.el-input .el-input__clear {
          width: 48px;
          color: #7B8395;
        }

        /deep/.el-input .el-input__clear:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-input .el-input__inner,
        /deep/.el-input .el-input__inner:hover {
          height: 48px;
          border-radius: 0px;
          border: none;
          background: #202D35;
          color: #ffffff;
          padding-left: 40px;
        }

        /deep/.el-input__prefix {
          left: -20px;
        }

        /deep/.el-input__icon {
          width: 40px;
        }

        /deep/.el-input__suffix {
          right: 0px;
        }

        /deep/.el-input__suffix:hover {
          background: @primaryColorTransparency30;
          color: rgb(255, 255, 255, 1);
        }

        /deep/.el-icon-circle-close:before {
          content: 'X'
        }

        /deep/.el-input:not(:last-child) {
          margin-right: 0px;
        }
      }

      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }

      // 日期盒子
      .datePreNext {
        padding: 0px 16px;
        border-left: 1px solid #7B8395;
        border-right: 1px solid #7B8395;

        .dateBox {
          /deep/.el-input__icon {
            width: 0px;
            line-height: 45px;
          }

          /deep/.el-icon-circle-close:before {
            content: "";
            display: inline-block;
            height: 16px;
            width: 16px;
            background: url(../../assets/img/general/Icon_SelectClear.png);
            background-repeat: no-repeat;
            background-size: 100%;
            background-position: center;
            // position: absolute;
            // top: 8px;
            // right: 16px;
          }
        }

        /deep/.datepicker {
          margin: 0px;
          // margin-right: 16px;
        }

        /deep/.el-date-editor {
          margin-right: 16px;
        }

        /deep/.el-date-editor.el-input {
          width: 150px;
        }

        /deep/.el-date-editor.el-input .el-input__inner {
          padding: 0px;
          text-align: center;
        }

        //.el-input__prefix,
        //.el-input__suffix
        /deep/.el-input__prefix {
          display: none;
        }

        /deep/.el-input__suffix {
          top: 2px;
          right: 16px;
        }

        .date-icon {
          display: inline-block;
          width: 24px;
          height: 24px;
          background: url(../../assets/img/general/Icon_Calendar.png);
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
          margin-right: 16px;
        }

        .date-pre {
          background: url(../../assets/img/general/Chart_Date_Pre.png);
        }

        .date-next {
          background: url(../../assets/img/general/Chart_Date_Next.png);
        }

        .date-btn {
          color: #ffffff;
          cursor: pointer;
          display: inline-block;
          height: 16px;
          width: 16px;
          background-size: 100%;
          background-position: center;
          background-repeat: no-repeat;
          vertical-align: middle;
        }
      }

      .search-label {
        display: inline-block;
        color: #ffffff;
        font-weight: bold;
        line-height: 48px;
        font-size: 14px;
        padding-left: 16px;
      }

      /deep/.el-select {
        width: 100px;
        border-right: 1px solid #738089;
      }

      /deep/.el-select:hover {
        background: @primaryColorTransparency30;
      }

      /deep/.el-select:not(:last-child),
      /deep/.search .el-input:not(:last-child) {
        margin-right: 0px;
      }

      /deep/.el-input {
        width: 100%;
        text-align: center;
      }

      /deep/.el-input__inner {
        background: transparent;
        border: none;
        height: 48px;
        line-height: 48px;
        color: #ffffff;
        padding: 0 16px;
      }

      /deep/.el-input__suffix {
        right: 0px;
      }

      .button {
        height: 48px;
        line-height: 48px;
        padding: 0 25px;
        margin-top: 0px;
        color: @primaryTextColor;
        background: transparent;
        border: none;
      }
    }

    // 批量操作弹条
    .batch-alert {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 48px;
      z-index: 1;
      background: rgba(255, 231, 107, 1);
      display: flex;
      align-items: center;
      justify-content: space-between;

      .batch-total {
        padding-left: 16px;
        font-size: 14px;
      }

      .batch-right {
        display: flex;
        justify-content: flex-end;
      }

      .batch-hide {
        height: 48px;
        line-height: 48px;
        padding: 0px 16px;
        cursor: pointer;
        font-size: 14px;

        &:hover {
          background: rgba(255, 255, 255, 1);
        }
      }

      .batch-operate {
        display: flex;
        justify-content: flex-end;

        .btn {
          color: rgba(34, 45, 53, 1);
          font-size: 14px;
          cursor: pointer;
          // display: inline-block;
          height: 48px;
          line-height: 48px;
          padding: 0px 16px;
          border-radius: 0px;
          display: flex;
          align-items: center;

          &:hover {
            background: rgba(255, 255, 255, 1);
          }
        }

        .ico-copy {
          background: url(../..//assets/img/general/Icon_Batch_Copy.png);
        }

        .ico-export {
          background: url(../../assets/img/general/Icon_Batch_Export.png);
        }

        .ico-clear {
          background: url(../../assets/img/general/Icon_Batch_Delete.png);
        }

        .ico-more {
          background: url(../../assets/img/general/Icon_Batch_More.png);
        }

        .ico {
          display: inline-block;
          width: 16px;
          height: 16px;
          background-repeat: no-repeat;
          background-size: 100%;
          background-position: center;
          margin-left: 8px;
        }

        // 批量更多下拉 (不可scoped)(.dropdown-more)
      }
    }

    .tableloding {

      // 加载数据时遮罩
      /deep/.el-loading-mask {
        background-color: rgb(34, 45, 53, .5);
      }

      /deep/.el-loading-spinner i {
        color: @primaryTextColor;
      }
    }

    .tablemain {
      border: none;
      background-color: rgb(34, 45, 53);

      .redirect {
        color: @primaryTextColor;
      }

      .operation i {
        color: @primaryTextColor;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        width: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner {
        width: 16px;
        height: 16px;
        background: transparent;
        border: 1px solid rgb(180, 184, 193);
        border-radius: 0px;
      }

      /deep/.el-checkbox .el-checkbox__input .el-checkbox__inner::after {
        top: 2px;
        left: 5px;
      }

      /deep/.el-table__header th {
        height: 48px;
      }

      /deep/.el-table__header th.is-leaf {
        border-color: rgba(198, 209, 221, 0.5);
        // border-bottom: none;
      }

      /deep/.el-table__header th>.cell {
        font-weight: normal;
        font-size: 12px;
      }

      /deep/.el-table__body tr,
      /deep/.el-table__body td {
        background-color: rgb(34, 45, 53);
        color: #ffffff;
        border-color: rgba(198, 209, 221, 0.5);
      }

      /deep/.el-table__body td.el-table-column--selection {
        background-color: rgb(65, 80, 90);
        color: #ffffff;
      }

      /deep/.el-table__body .cell.el-tooltip {
        font-size: 14px;
      }

      // 右侧固定
      /deep/.el-table__fixed-right::before,
      /deep/.el-table__fixed::before {
        display: none;
      }

      ::-webkit-scrollbar {
        width: 6px;
        height: 6px;
        background-color: #222d35;
      }

      /deep/.el-table--border::after,
      /deep/.el-table--group::after {
        display: none;
      }

      // 关于复选框
      /deep/.el-checkbox .el-checkbox__input.is-checked .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      /deep/.el-checkbox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background: @primaryTextColor;
        border: 1px solid @primaryTextColor;
      }

      // 关于头部右侧空白
      /deep/.el-table__fixed-right-patch {
        background-color: rgb(65, 80, 90);
        border-bottom: none;
      }

      /deep/th.gutter {
        background-color: rgb(65, 80, 90);
      }
    }

    .tablebottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-top: 1px solid rgba(198, 209, 221, 0.5);

      // 分页
      .pagination {
        line-height: 48px;
        height: 48px;
        padding: 0;
        margin: 0;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-right: 16px;

        /deep/.el-pager li {
          vertical-align: middle;
        }

        /deep/.el-select .el-input {
          width: 90px;
          margin: 0px;
        }

        /deep/.el-input .el-input__inner {
          background-color: #202D35;
          color: #ffffff;
        }

        /deep/.el-input__suffix {
          right: 10px;
        }

        /deep/.el-pagination__sizes {
          margin: 0px;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pagination__total {
          color: #fff;
          padding-left: 15px;
          border-left: 1px solid #7B8395;
          height: 48px;
          line-height: 48px;
        }

        /deep/.el-pager li:not(.disabled).active {
          // background: #15C491;
          // color: #ffffff;
          background-color: #2B3842;
          color: #15C491;
        }

        // li:not(.disabled):not(.active):hover
        /deep/.el-pager li:not(.disabled):hover {
          background-color: @primaryColorTransparency30;
          color: rgba(255, 255, 255, 1);
        }

        /deep/.el-pager li {
          background-color: #2B3842;
          color: #7B8395;
        }

        // 页条数下拉
        /deep/.el-select .el-input .el-input__inner {
          border: none;
          height: 48px;
          line-height: 48px;
          border-radius: 0px;
        }

        /deep/.el-select .el-input .el-input__inner:hover {
          background: @primaryColorTransparency30;
        }

        // 跳页
        /deep/.el-pagination__jump {
          color: #ffffff;
        }

        /deep/.el-pagination__editor {
          padding: 0px 6px;
        }

        /deep/.el-pagination__editor.el-input .el-input__inner {
          border: 1px solid #7B8395;
        }
      }

      // 分页前后按钮
      /deep/.el-pagination.is-background .btn-next,
      /deep/.el-pagination.is-background .btn-prev {
        background-color: #2B3842;
        color: #7B8395;
      }

      /deep/.el-pagination.is-background .btn-next:hover,
      /deep/.el-pagination.is-background .btn-prev:hover {
        background-color: @primaryColorTransparency30;
        color: rgba(255, 255, 255, 1);
      }

      /deep/.el-pagination.is-background button[disabled],
      /deep/.el-pagination.is-background button[disabled]:hover {
        background-color: #2B3842;
        color: #7B8395;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    background-color: #222d35;
  }
  /deep/.el-range__icon{
    margin-left:25px;
  }
  /deep/.el-date-editor--daterange {
    color: #fff;
    background-color: #2b3842;
  }

  /deep/.el-range-input {
    color: #fff;
    background-color: #222d35;
    width: 160px;
  }

  /deep/.el-range-separator {
    color: #fff;
    width:18%;
    line-height: 48px;
  }
  /deep/.el-icon-date:before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 12px;
    left: 10px;
    height: 24px;
    width: 24px;
    background: url(../../assets/img/general/Icon_Calendar.png) no-repeat;
    background-size: 100%;
    background-position: center;
  }

  // 日期筛选
  .alrm-date {
    /deep/.el-icon-date:before {
      content: "";
    }

    /deep/.el-input__prefix .el-input__icon:before {
      content: "";
      display: inline-block;
      position: absolute;
      top: 12px;
      right: -2px;
      height: 20px;
      width: 20px;
      background: url(../../assets/img/general/Icon_Down_Border.png) no-repeat;
      background-size: 100%;
      background-position: center;
    }
  }

  // Loading
  .el-loading-spinner .path {
    stroke: @primaryTextColor !important;
  }
}

// 下拉选中项高亮
// .select-search-recharge {
//   .el-select-dropdown__item.selected {
//     background-color: blue!important;
//     color: #ffffff;
//   }
// }
</style>
<style lang="less">
body,
div,
span,
header,
footer,
nav,
section,
aside,
article,
ul,
dl,
dt,
dd,
li,
a,
p,
h1,
h2,
h3,
h4,
h5,
h6,
i,
b,
textarea,
button,
input,
select,
figure,
figcaption {
  // font-weight: 100;
  font-family: Microsoft YaHei;
}
.select-date1.el-picker-panel {
  background-color: #222D35;
  border: none;
  padding-top: 10px;

  .el-picker-panel__body-wrapper {
    .el-picker-panel__body {
      border: #222D35;
    }

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }

  .el-date-range-picker__header {
    color: #fff;
  }

  .in-range {
    background-color: #222D35;
  }

  .el-picker-panel__shortcut:hover {
    padding-left: 0px;
    padding-bottom: 20px;
    color: @primaryTextColor;
    text-align: center;
  }

  .el-date-table td.today span {
    color: @primaryTextColor;
    font-weight: 700;
  }

  .el-date-table td.in-range div {
    background-color: rgba(48, 208, 150, 0.7);
  }

  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }
  

  .el-date-table td.end-date span,
  .el-date-table td.start-date span {
    color: #fff;
    background-color: @primaryTextColor;
    border: @primaryTextColor;
  }

  .el-date-table td.in-range {
    background-color: #222D35;
  }

  .el-date-table td:hover {
    color: rgba(48, 208, 150);
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: #606266;
  }

  .el-date-table td {
    color: #fff
  }
  .el-date-table td.disabled div {
    background-color: #222D35 !important;
    color: #606266 !important;
  }
}

// 筛选下拉菜单
.select-search-pro {
  width: 200px;
  background: #222D35;
  font-family: Microsoft YaHei;
  border-radius: 6px;
  ;
  box-shadow: 0px 8px 21px rgba(11, 12, 13, 0.3);
  border: none;

  .el-select-dropdown__wrap {
    max-height: 546px;
  }

  .el-select-group__wrap:not(:last-of-type)::after {
    height: 0px;
  }

  .el-select-group__title {
    padding-left: 16px;
    font-size: 14px;
    color: #ffffff;
    border-bottom: 1px solid #424E56;
    line-height: 39px;
    margin-top: 10px;
  }

  .el-select-dropdown__item {
    padding-left: 16px;
    font-size: 14px;
    text-align: left;
    background: #222D35;
    color: #ffffff;
    font-family: Microsoft YaHei;
  }

  .el-select-group__wrap {
    padding-bottom: 0px;
  }

  // .el-select-dropdown__item.hover {
  // }
  .el-select-dropdown__item:hover {
    background: #222D35;
    color: #ffffff;
  }

  .el-select-dropdown__item.selected:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_Duihao.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    margin-right: 5px;
    position: absolute;
    top: 6px;
    right: 12px;
  }
}

.el-table--border:after,
.el-table--group:after {
  display: none;
}

.selectClearNew {

  // 下拉选中清除按钮
  .el-icon-circle-close:before {
    content: "";
    display: inline-block;
    height: 16px;
    width: 16px;
    background: url(../../assets/img/general/Icon_SelectClear.png);
    background-repeat: no-repeat;
    background-size: 100%;
    background-position: center;
    // position: absolute;
    // top: 8px;
    // right: 16px;
  }
}

// #时间选择器 el-date-picker#
.select-date {

  // 下拉
  &.el-date-picker {
    background: rgba(34, 45, 53, 1);
    border: none;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.12), 0px 0px 1px rgba(0, 0, 0, 0.48);
  }

  // 切换日 -----
  // 头部切换
  .el-date-picker__header {
    padding: 0px 50px;
  }

  .el-date-picker__header-label {
    color: rgba(238, 236, 241, 1);
  }

  // 前后切换
  .el-picker-panel__icon-btn {
    color: rgba(48, 208, 150);
    font-size: 14px;
    font-weight: bold;
  }

  // 一周
  .el-date-table th {
    color: rgba(238, 236, 241, 1);
    border: none;
  }

  // 日
  .el-date-table td div {
    padding: 0px;
  }

  .el-date-table td.today span {
    color: #00FEBB;
    font-weight: normal;
  }

  .el-date-table td.available {
    color: rgba(122, 117, 133, 1);
    font-size: 14px;
  }

  .el-date-table td.available:hover {
    color: #00FEBB;
  }

  .el-date-table td.current:not(.disabled) span {
    width: 30px;
    height: 30px;
    line-height: 26px;
    text-align: center;
    border-radius: 16px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    margin-top: -3px;
  }

  .el-date-table td.next-month,
  .el-date-table td.prev-month {
    color: rgb(60, 56, 68);
    font-size: 16px;
  }

  // 切换月 -----
  .el-date-picker__header--bordered {
    border: none;
  }

  // 月
  .el-month-table td.today .cell {
    color: #00FEBB;
  }

  .el-month-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 32px;
  }

  .el-month-table td .cell {
    color: #7B8395;
  }

  .el-month-table td .cell:hover {
    color: #00FEBB;
  }

  // 切换年 -----
  // 年
  .el-year-table td.today .cell {
    color: #00FEBB;
  }

  .el-year-table td.current:not(.disabled) .cell {
    border-radius: 6px;
    border: 2px solid @primaryColorTransparency30;
    background: @primaryColorTransparency30;
    color: rgba(51, 255, 182, 1);
    line-height: 28px;
  }

  .el-year-table td .cell {
    color: #7B8395;
  }

  .el-year-table td .cell:hover {
    color: #00FEBB;
  }
}

// 日期选择器增加今日快捷
.select-date {
  width: 320px !important;
  padding-top: 10px;

  // 头部
  .el-date-picker__header {
    width: 100%;
    margin: 12px 0px !important;
    padding: 0px 30px !important;
  }

  .el-picker-panel__body-wrapper {
    display: flex;
    flex-direction: column-reverse;
    justify-content: flex-end;
    align-items: flex-end;

    .el-picker-panel__sidebar {
      width: 100%;
      position: relative;
      padding: 0px;
      background: transparent;
      color: #ffffff;
      border: none;

      .el-picker-panel__shortcut,
      .el-picker-panel__shortcut:hover {
        // margin-top: 0px;
        padding-left: 0px;
        padding-bottom: 20px;
        color: @primaryTextColor;
        text-align: center;
      }
    }
  }
}

// #操作结果提示#
.showresultbox {
  display: flex;
  flex-direction: column;
  align-items: center;

  // 图标
  .showsuccess {
    border: 3px solid rgba(37, 255, 174, 1);
    background-color: rgba(19, 195, 156, 1);
    background-image: url(../../assets/img/general/Icon_Finished.png);
    background-size: 70px 70px;
  }

  .showfail {
    border: 3px solid rgba(246, 189, 189, 1);
    background: rgba(251, 75, 75, 1);
    background-image: url(../../assets/img/general/Icon_Failed.png);
    background-size: 120px 120px;
  }

  .showbase {
    width: 100px;
    height: 100px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-position: center;
    border-radius: 50%;
  }

  // 提示
  .showresulttext {
    font-weight: bold;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 30px;
    color: rgba(255, 255, 255, 1);
  }

  // 操作
  .showoperate {
    text-align: center;
  }

  .showresultbtn {
    width: 102px;
    height: 30px;
    margin-top: 10px;
    border-radius: 6px;
    background: @primaryTextColor;
    color: rgba(34, 45, 53, 1);
    font-size: 14px;
  }
}
</style>
<style lang="less">
.deviceName .el-tooltip {
  color: @primaryTextColor;
}
</style>
